// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Search-root-ZdUuW {
	padding-left: 0px;
	padding-right: 0px;
}

.Search-container-Gvv_1 {
	margin: 0 auto;
	padding: 103px 0px 0px;
	max-width: 100%;
	margin-top: 0px;
}

.Search-searchLoaderContainer-KPPHt {
	position: absolute;
	top: 30%;
	left: 0;
	right: 0;
}

.Search-searchResultContainer-Ep7pX {
	left: 0;
	bottom: 0;
	width: 100%;
	overflow-x: hidden;
	z-index: 0;
}

.Search-searchMapContainer-UPGbZ {
	width: 100%;
	position: fixed;
	right: 0;
	left: auto;
	bottom: 0;
	top: 176px;
	padding: 24px 24px 24px 0px;
}

.Search-mobileNavigation-Ommph {
	position: fixed;
	bottom: 5px;
	left: 0;
	right: 0;
	opacity: 1;
	text-align: center;
	-webkit-transition-duration: 250ms;
	        transition-duration: 250ms;
	-webkit-transition-property: opacity;
	transition-property: opacity;
	-webkit-transition-timing-function: ease-out;
	        transition-timing-function: ease-out;
	z-index: 5;
	display: none;
}

.Search-buttonOuter-ebgwp {
	display: inline-block;
	width: 100%;
}

.Search-buttonContainer-VpHYe {
	background-color: transparent;
	color: var(--common-text-color);
	float: left;
	font-family: inherit;
	font-size: 12px;
	font-weight: 700;
	letter-spacing: 0.4px;
	line-height: 1;
	margin: 0;
	padding-bottom: 0;
	padding-top: 0;
	width: 100%;
}

.Search-filterButton-PqEF9,
.Search-filterButton-PqEF9:hover,
.Search-filterButton-PqEF9:focus,
.Search-filterButton-PqEF9:active:focus {
	color: #006c70;
	text-decoration: none;
	padding: 10px 15px;
	-webkit-box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.14);
	        box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.14);
	background-color: var(--primary-white-bg);
	border-radius: 80px;
	outline: 0;
}

.Search-filterButton-PqEF9 .Search-icon-y_xK0 {
	font-size: 20px;
}

.Search-filterButton-PqEF9:last-child {
	border: none;
}

.Search-locationBtn-WoJ1Y,
.Search-locationBtn-WoJ1Y:hover,
.Search-locationBtn-WoJ1Y:focus,
.Search-locationBtn-WoJ1Y:active:focus {
	padding: 10px;
	border-radius: 6px;
	font-size: 16px;
	font-weight: 500;
	color: var(--common-text-color);
}

.Search-locationBtn-WoJ1Y .Search-icon-y_xK0 {
	font-size: 40px;
}

.Search-middle-JE0qO {
	vertical-align: middle;
}

.Search-hideIcon-O99j1 {
	display: none;
}

@media screen and (min-width: 1200px) {
	.Search-searchMapContainerShow-AhKMw {
		display: block;
		width: 100% !important;
		padding: 24px 24px 24px 24px;
	}

	.Search-searchResultContainer-Ep7pX {
		margin-top: 15px;
	}

	.Search-searchMapContainer-UPGbZ {
		display: block;
		width: 50%;
	}

	.Search-listItemOnly-j1zsn.Search-searchResultContainer-Ep7pX {
		width: 100% !important;
	}

	.Search-searchResultContainer-Ep7pX {
		width: 50%;
		display: block;
	}

}

@media screen and (max-width: 1199px) {
	.Search-mobileNavigation-Ommph {
		display: block;
	}

	.Search-searchMapContainer-UPGbZ {
		width: 100%;
		top: 100px;
		padding: 0;
	}

	.Search-locationBtn-WoJ1Y {
		float: none !important;
	}
}

@media (max-width: 1199px) {
	.Search-searchResultContainer-Ep7pX {
		width: 100%;
	}
}

@media screen and (max-width: 767px) {
	.Search-container-Gvv_1 {
		padding: 64px 0px 0px;
	}
}

@media screen and (max-width: 900px) {

	.Search-listItemOnly-j1zsn.Search-searchResultContainer-Ep7pX {
		width: 100% !important;
	}
}

@media screen and (max-width: 768px) {
	.Search-resultsBody-NCGZE {
		display: block;
	}

	.Search-searchResultContainer-Ep7pX {
		width: 100%;
	}

	.Search-listItemOnly-j1zsn.Search-searchResultContainer-Ep7pX {
		width: 100% !important;
		margin-top: 0px;
	}

	.Search-searchMapContainer-UPGbZ {
		width: 100%;
		padding: 0px;
		top: 100px;
	}
}`, "",{"version":3,"sources":["webpack://./src/routes/search/Search.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,sBAAsB;CACtB,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,QAAQ;AACT;;AAEA;CACC,OAAO;CACP,SAAS;CACT,WAAW;CACX,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,eAAe;CACf,QAAQ;CACR,UAAU;CACV,SAAS;CACT,UAAU;CACV,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,WAAW;CACX,OAAO;CACP,QAAQ;CACR,UAAU;CACV,kBAAkB;CAClB,kCAA0B;SAA1B,0BAA0B;CAC1B,oCAA4B;CAA5B,4BAA4B;CAC5B,4CAAoC;SAApC,oCAAoC;CACpC,UAAU;CACV,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,6BAA6B;CAC7B,+BAA+B;CAC/B,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,cAAc;CACd,SAAS;CACT,iBAAiB;CACjB,cAAc;CACd,WAAW;AACZ;;AAEA;;;;CAIC,cAAc;CACd,qBAAqB;CACrB,kBAAkB;CAClB,qDAA6C;SAA7C,6CAA6C;CAC7C,yCAAyC;CACzC,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,YAAY;AACb;;AAEA;;;;CAIC,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,+BAA+B;AAChC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC;EACC,cAAc;EACd,sBAAsB;EACtB,4BAA4B;CAC7B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,cAAc;EACd,UAAU;CACX;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;EACV,cAAc;CACf;;AAED;;AAEA;CACC;EACC,cAAc;CACf;;CAEA;EACC,WAAW;EACX,UAAU;EACV,UAAU;CACX;;CAEA;EACC,sBAAsB;CACvB;AACD;;AAEA;CACC;EACC,WAAW;CACZ;AACD;;AAEA;CACC;EACC,qBAAqB;CACtB;AACD;;AAEA;;CAEC;EACC,sBAAsB;CACvB;AACD;;AAEA;CACC;EACC,cAAc;CACf;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,sBAAsB;EACtB,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,UAAU;CACX;AACD","sourcesContent":[".root {\n\tpadding-left: 0px;\n\tpadding-right: 0px;\n}\n\n.container {\n\tmargin: 0 auto;\n\tpadding: 103px 0px 0px;\n\tmax-width: 100%;\n\tmargin-top: 0px;\n}\n\n.searchLoaderContainer {\n\tposition: absolute;\n\ttop: 30%;\n\tleft: 0;\n\tright: 0;\n}\n\n.searchResultContainer {\n\tleft: 0;\n\tbottom: 0;\n\twidth: 100%;\n\toverflow-x: hidden;\n\tz-index: 0;\n}\n\n.searchMapContainer {\n\twidth: 100%;\n\tposition: fixed;\n\tright: 0;\n\tleft: auto;\n\tbottom: 0;\n\ttop: 176px;\n\tpadding: 24px 24px 24px 0px;\n}\n\n.mobileNavigation {\n\tposition: fixed;\n\tbottom: 5px;\n\tleft: 0;\n\tright: 0;\n\topacity: 1;\n\ttext-align: center;\n\ttransition-duration: 250ms;\n\ttransition-property: opacity;\n\ttransition-timing-function: ease-out;\n\tz-index: 5;\n\tdisplay: none;\n}\n\n.buttonOuter {\n\tdisplay: inline-block;\n\twidth: 100%;\n}\n\n.buttonContainer {\n\tbackground-color: transparent;\n\tcolor: var(--common-text-color);\n\tfloat: left;\n\tfont-family: inherit;\n\tfont-size: 12px;\n\tfont-weight: 700;\n\tletter-spacing: 0.4px;\n\tline-height: 1;\n\tmargin: 0;\n\tpadding-bottom: 0;\n\tpadding-top: 0;\n\twidth: 100%;\n}\n\n.filterButton,\n.filterButton:hover,\n.filterButton:focus,\n.filterButton:active:focus {\n\tcolor: #006c70;\n\ttext-decoration: none;\n\tpadding: 10px 15px;\n\tbox-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.14);\n\tbackground-color: var(--primary-white-bg);\n\tborder-radius: 80px;\n\toutline: 0;\n}\n\n.filterButton .icon {\n\tfont-size: 20px;\n}\n\n.filterButton:last-child {\n\tborder: none;\n}\n\n.locationBtn,\n.locationBtn:hover,\n.locationBtn:focus,\n.locationBtn:active:focus {\n\tpadding: 10px;\n\tborder-radius: 6px;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tcolor: var(--common-text-color);\n}\n\n.locationBtn .icon {\n\tfont-size: 40px;\n}\n\n.middle {\n\tvertical-align: middle;\n}\n\n.hideIcon {\n\tdisplay: none;\n}\n\n@media screen and (min-width: 1200px) {\n\t.searchMapContainerShow {\n\t\tdisplay: block;\n\t\twidth: 100% !important;\n\t\tpadding: 24px 24px 24px 24px;\n\t}\n\n\t.searchResultContainer {\n\t\tmargin-top: 15px;\n\t}\n\n\t.searchMapContainer {\n\t\tdisplay: block;\n\t\twidth: 50%;\n\t}\n\n\t.listItemOnly.searchResultContainer {\n\t\twidth: 100% !important;\n\t}\n\n\t.searchResultContainer {\n\t\twidth: 50%;\n\t\tdisplay: block;\n\t}\n\n}\n\n@media screen and (max-width: 1199px) {\n\t.mobileNavigation {\n\t\tdisplay: block;\n\t}\n\n\t.searchMapContainer {\n\t\twidth: 100%;\n\t\ttop: 100px;\n\t\tpadding: 0;\n\t}\n\n\t.locationBtn {\n\t\tfloat: none !important;\n\t}\n}\n\n@media (max-width: 1199px) {\n\t.searchResultContainer {\n\t\twidth: 100%;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.container {\n\t\tpadding: 64px 0px 0px;\n\t}\n}\n\n@media screen and (max-width: 900px) {\n\n\t.listItemOnly.searchResultContainer {\n\t\twidth: 100% !important;\n\t}\n}\n\n@media screen and (max-width: 768px) {\n\t.resultsBody {\n\t\tdisplay: block;\n\t}\n\n\t.searchResultContainer {\n\t\twidth: 100%;\n\t}\n\n\t.listItemOnly.searchResultContainer {\n\t\twidth: 100% !important;\n\t\tmargin-top: 0px;\n\t}\n\n\t.searchMapContainer {\n\t\twidth: 100%;\n\t\tpadding: 0px;\n\t\ttop: 100px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Search-root-ZdUuW`,
	"container": `Search-container-Gvv_1`,
	"searchLoaderContainer": `Search-searchLoaderContainer-KPPHt`,
	"searchResultContainer": `Search-searchResultContainer-Ep7pX`,
	"searchMapContainer": `Search-searchMapContainer-UPGbZ`,
	"mobileNavigation": `Search-mobileNavigation-Ommph`,
	"buttonOuter": `Search-buttonOuter-ebgwp`,
	"buttonContainer": `Search-buttonContainer-VpHYe`,
	"filterButton": `Search-filterButton-PqEF9`,
	"icon": `Search-icon-y_xK0`,
	"locationBtn": `Search-locationBtn-WoJ1Y`,
	"middle": `Search-middle-JE0qO`,
	"hideIcon": `Search-hideIcon-O99j1`,
	"searchMapContainerShow": `Search-searchMapContainerShow-AhKMw`,
	"listItemOnly": `Search-listItemOnly-j1zsn`,
	"resultsBody": `Search-resultsBody-NCGZE`
};
module.exports = ___CSS_LOADER_EXPORT___;
